var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"course-video"}},[_c('LecturesMenu'),_c('div',{staticClass:"wrapper"},[_c('button',{staticClass:"btn w-auto",on:{"click":function($event){return _vm.setCurrentCourse(_vm.flow.lecture)}}},[_vm._v("\n            powrót\n        ")]),_c('div',{staticClass:"mt-5 mb-5",domProps:{"innerHTML":_vm._s(_vm.finalWords)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }